import { NormalContainerWithHeader } from '../../shared/components/student/NormalComponent'
import { Box, Button, Grid2, Tooltip, Typography } from '@mui/material'
import CustomDivider from '../../shared/utils/CustomDivider'
import { Grid_Gap, Input_Width } from '../../shared/constants'
import { Field, Form, Formik } from 'formik'
import { PhoneInputFormField } from '../../shared/components/formfields/PhoneInputFormField'
import { useApartmentListForCourse, useStudentCourseNameList } from '../../assets/api/useAdminApi'
import { AutoCompleteField } from '../../shared/components/formfields/AutoCompleteField'
import { TextFormField } from '../../shared/components/formfields/TextFormField'
import * as Yup from 'yup';
import { useMutation, useQueryClient } from '@tanstack/react-query'
import useAuthStore from '../../store/useAuthStore'
import { useToaster } from '../../shared/utils/ToasterProvider'
import { isValidPhoneNumber } from 'react-phone-number-input'
import { useCoordinatorStudentEnList, useLeadStudentList, useZoneHeadManagerStudentEnList } from '../../assets/api/useCoordinatorApi'
import useStudentDetailStore from '../../store/useStudentDetailStore'
import { useEffect, useState } from 'react'
import { useTrainerStudentEnList } from '../../assets/api/useTrainerGetApi'
import { IdAutoCompleteField } from '../../shared/components/formfields/IdAutoCompleteField'
import TableFilterTemplate from '../../shared/utils/TableFilterTemplate'
import { GridActionsCellItem } from '@mui/x-data-grid'
import EditIcon from '@mui/icons-material/Edit';
import api from '../../assets/nodeApi/axiosInstance'


const StudentEnquiryForm = () => {
    const queryClient = useQueryClient();
    const { token } = useAuthStore()
    const { user } = useAuthStore()
    const { showToaster } = useToaster();
    const [filters, setFilters] = useState({});
    const { studentDetail, clearStudentDetail, setStudentDetail } = useStudentDetailStore();
    const [selectedApartment, setSelectedApartment] = useState(null);
    useEffect(() => {
        setSelectedApartment(studentDetail?.apartment_id)
    }, [studentDetail?.apartment_id]);
    const { data: apartmentList, isLoading: isLoadingApartmentList } = useApartmentListForCourse();
    
    const { data: studentListAll, isLoading: isStudentListLoading } = useLeadStudentList();
    const { data: studentListcor, isLoading: isStudentListLoadingcor } = useCoordinatorStudentEnList();
    const { data: studentListzone, isLoading: isStudentListLoadingzone } = useZoneHeadManagerStudentEnList();
    const { data: studentListzoneTrainer, isLoading: isStudentListLoadingzoneTrainer } = useTrainerStudentEnList();

    let studentList;
    let isLoading;

    if (user.role === 'coordinator') {
        studentList = studentListcor;
        isLoading = isStudentListLoadingcor;
    } else if (user.role === 'Zone Manager' || user.role === 'Zone Head') {
        studentList = studentListzone;
        isLoading = isStudentListLoadingzone;
    }
    else if (user.role === 'trainer') {
        studentList = studentListzoneTrainer;
        isLoading = isStudentListLoadingzoneTrainer;
    } else {
        studentList = studentListAll;
        isLoading = isStudentListLoading;
    }
    const uniqueApartments = new Set();
    const ApartmentOptionFilter = (studentList?.data || [])
        .filter(item => {
            const name = item?.apartment_name;
            if (!name || uniqueApartments.has(name)) return false;
            uniqueApartments.add(name);
            return true;
        })
        .map((item, index) => ({
            id: index + 1,
            value: item.apartment_name,
            label: item.apartment_name,
        }));

    const uniqueStatuses = new Set();
    const StatusOptionFilter = (studentList?.data || [])
        .filter(item => {
            const status = item?.status;
            if (!status || uniqueStatuses.has(status)) return false;
            uniqueStatuses.add(status);
            return true;
        })
        .map((item, index) => ({
            id: index + 1,
            label: item.status,
            value: item.status,
        }));
    const ApartmentOptions = apartmentList?.data?.map((item, index) => ({
        id: item?.id,
        label: item?.apartment_name,
        value: item?.apartment_name,
    })) || [];
    const { data: courseList, isLoading: isCourseLoading } = useStudentCourseNameList();
    const CourseOption = courseList?.data.map(course => ({
        id: course?.id,
        label: course?.course_name,
        value: course?.course_name,
    })) || [];
    const initialValues = {
        student_name: studentDetail?.student_name || '',
        parent_name: studentDetail?.parent_name || '',
        apartment_name: studentDetail?.apartment_name || '',
        school_name: studentDetail?.school_name || '',
        contact_number: studentDetail?.contact_number || '',
        email: studentDetail?.email || '',
        status: studentDetail?.status || '',
        remarks: studentDetail?.remarks || '',
        course_id: studentDetail?.course_id || '',
    };

    const validationSchema = Yup.object().shape({
        student_name: Yup.string()
            .required('Student name is required'),

        parent_name: Yup.string()
            .required('Parent name is required'),

        apartment_name: Yup.string()
            .required('Apartment name is required'),

        school_name: Yup.string()
            .required('School name is required'),
        contact_number: Yup.string().test(
            "is-phone",
            "Phone number is not valid",
            (value) => value && isValidPhoneNumber(value)
        ).required("Mobile Number is required"),

        email: Yup.string()
            .email('Enter a valid email')
            .required('Email is required'),

        status: Yup.string()
            .required('Status is required'),

        remarks: Yup.string()
            .required('Remark is required'),
        course_id: Yup.string()
            .required('Course is required'),
    });

    const mutation = useMutation({
        mutationFn: (formData) => {
            return studentDetail?.id
                ? api.put(`student-leads/${studentDetail?.id}`, formData,
                    {
                        headers: {
                            Authorization: `Bearer ${token}`,
                        },
                    }
                )
                : api.post(`student-leads`, formData,
                    {
                        headers: {
                            Authorization: `Bearer ${token}`,
                        },
                    }
                );
        },
        onSuccess: (response) => {
            showToaster('Success', response?.data?.message, 'success')
            queryClient.invalidateQueries({ queryKey: ['student-leads'] });
            clearStudentDetail()
        },
        onError: () => {
            showToaster("Error Caught While submiting the form", 'Error', 'error');
        },
    });
    const handleSubmit = (values, { setSubmitting, resetForm }) => {
        const data = {
            ...values,
            apartment_id: selectedApartment,
            created_by: user?.id
        }
        mutation.mutate(data, {
            onSettled: () => {
                setSubmitting(false);
            },
            onSuccess: () => {
                resetForm();
            }
        });

    }

    const statusOption = [
        {
            id: 1,
            value: "Added",
            label: "Added"
        },
        {
            id: 2,
            value: "onboarded",
            label: "Onboarded"
        },
        {
            id: 3,
            value: "notinterested",
            label: "Notinterested"
        },
        {
            id: 4,
            value: "Created",
            label: "Created"
        },
    ]



    const studentColumn = [
        {
            field: "sr_no",
            headerName: "Sr No",

            width: 150,
            renderCell: (params) => <Typography variant="body2">{params.value}</Typography>

        },
        {
            field: "event_title",
            headerName: "Course Name",
            width: 150,
            renderCell: (params) => <Typography variant="body2">{params.value}</Typography>,
        },
        {
            field: "student_name",
            headerName: "Student Name",
            width: 150,
            renderCell: (params) => <Typography variant="body2">{params.value}</Typography>,
        },
        {
            field: "parent_name",
            headerName: "Parent Name",
            width: 150,
            renderCell: (params) => <Typography variant="body2">{params.value}</Typography>,
        },
        {
            field: "apartment_name",
            headerName: "Apartment Name",
            width: 150,
            renderCell: (params) => <Typography variant="body2">{params.value}</Typography>,
        },
        {
            field: "school_name",
            headerName: "School Name",
            width: 150,
            renderCell: (params) => <Typography variant="body2">{params.value}</Typography>,
        },
        {
            field: "contact_number",
            headerName: "Contact Number",
            width: 150,
            renderCell: (params) => <Typography variant="body2">{params.value}</Typography>,
        },
        {
            field: "email",
            headerName: "Email",
            width: 150,
            renderCell: (params) => <Typography variant="body2">{params.value}</Typography>,
        },
        {
            field: "status",
            headerName: "Status",
            width: 150,
            renderCell: (params) => <Typography variant="body2">{params.value}</Typography>,
        },
        {
            field: "remarks",
            headerName: "Remarks",
            width: 150,
            renderCell: (params) => <Typography variant="body2">{params.value}</Typography>,
        },
        // {
        //     field: "created_by_name",
        //     headerName: "Created By",
        //     width: 150,
        //     renderCell: (params) => <Typography variant="body2">{params.value}</Typography>,
        // },
        {
            field: "actions",
            type: "actions",
            headerName: "Actions",
            width: 150,
            cellClassName: "actions",
            renderCell: (params) => (
                <Box sx={{ display: "flex", justifyContent: "center", width: "100%" }}>
                    <Tooltip title="Edit">
                        <GridActionsCellItem
                            key={0}
                            icon={<EditIcon />}
                            label="Edit"
                            onClick={() => {
                                setStudentDetail(params.row);
                                window.scrollTo({ top: 0, behavior: 'smooth' });

                            }}
                        />
                    </Tooltip>
                </Box>
            ),
        }
    ]
    return (
        <>
            <NormalContainerWithHeader headerText={"Student Enquiry Form"}>
                <CustomDivider />
                <Formik
                    initialValues={initialValues}
                    validationSchema={validationSchema}
                    onSubmit={handleSubmit}
                    enableReinitialize={true}
                >
                    {({ resetForm }) => (
                        <Form>
                            <Grid2 container spacing={5}>
                                <Grid2 children size={Input_Width}>
                                    <Field
                                        name="student_name"
                                        component={TextFormField}
                                        label="Student Name"
                                        isRequired={true}
                                    />
                                </Grid2>
                                <Grid2 children size={Input_Width}>
                                    <Field
                                        name="parent_name"
                                        component={TextFormField}
                                        label="Parent Name"
                                        isRequired={true}
                                    />
                                </Grid2>
                                <Grid2 children size={Input_Width}>
                                    <Field
                                        name="course_id"
                                        component={IdAutoCompleteField}
                                        options={CourseOption}
                                        isLoading={isCourseLoading}
                                        label="Select Course"
                                        isRequired={true}
                                    />
                                </Grid2>
                                <Grid2 children size={Input_Width}>
                                    <Field
                                        name="apartment_name"
                                        component={AutoCompleteField}
                                        options={ApartmentOptions}
                                        label="Apartment Name"
                                        isRequired={true}
                                        isLoading={isLoadingApartmentList}
                                        onValueChange={(val) => setSelectedApartment(val?.id)}
                                    />
                                </Grid2>
                                <Grid2 children size={Input_Width}>
                                    <Field
                                        name="school_name"
                                        component={TextFormField}
                                        option
                                        label="School Name"
                                        isRequired={true}
                                    />
                                </Grid2>
                                <Grid2 children size={Input_Width}>
                                    <Field
                                        name="contact_number"
                                        component={PhoneInputFormField}
                                        label="Contact Number"
                                        isRequired={true}
                                    />
                                </Grid2>
                                <Grid2 children size={Input_Width}>
                                    <Field
                                        name="email"
                                        component={TextFormField}
                                        label="email"
                                        type="email"
                                        isRequired={true}
                                    />
                                </Grid2>
                                <Grid2 children size={Input_Width}>
                                    <Field
                                        name="status"
                                        component={AutoCompleteField}
                                        options={statusOption}
                                        label="Status"
                                        isRequired={true}
                                    />
                                </Grid2>
                                <Grid2 children size={Input_Width}>
                                    <Field
                                        name="remarks"
                                        component={TextFormField}
                                        label="Remark"
                                        isRequired={true}
                                    />
                                </Grid2>

                            </Grid2>
                            <CustomDivider />
                            <Grid2 container spacing={Grid_Gap} sx={{justifyContent:"end"}}>
                                <Grid2 size={{ xs: 12, sm: 6, md: 3 }}>
                                    <Button fullWidth variant="outlined" onClick={() => { resetForm(); clearStudentDetail(); }} > Clear </Button>
                                </Grid2>
                                <Grid2 size={{ xs: 12, sm: 6, md: 3 }}>
                                    <Button fullWidth variant="contained" type="submit"> {Object.keys(studentDetail).length === 0 ? "Submit" : "Update"}</Button>
                                </Grid2>
                            </Grid2>
                        </Form>
                    )}
                </Formik>
                <CustomDivider />
                {/* <Grid2 container spacing={Grid_Gap}>
                    <Grid2 size={{ xs: 12, sm: 6, md: 4 }} >
                        <Button variant='contained' onClick={handleClickOpen} fullWidth> Add Marketing Manger</Button>
                    </Grid2>
                    <Grid2 size={{ xs: 12, sm: 6, md: 4 }}>
                        <Button variant='contained' onClick={handleClickOpenStudent} fullWidth>Add Student</Button>
                    </Grid2>

                </Grid2> */}

            </NormalContainerWithHeader>
            <CustomDivider />

            <TableFilterTemplate
                title="Student List"
                columns={studentColumn}
                rowsData={studentList?.data || []}
                isLoading={isLoading}
                filterInitialValues={filters}
                filters={filters}
                filterReset={() => setFilters({})}
                onApplyFilters={(f) => setFilters(f)}
                renderFilterFields={() => (

                    <>
                        <Grid2 children size={12}>
                            <Field
                                name="apartment_name"
                                component={AutoCompleteField}
                                options={ApartmentOptionFilter}
                                label="Apartment Name"
                                isRequired={true}
                                isLoading={isLoadingApartmentList}
                            />
                        </Grid2>

                        <Grid2 children size={12}>
                            <Field
                                name="status"
                                component={AutoCompleteField}
                                options={StatusOptionFilter}
                                label="Status"
                                isRequired={true}
                            />
                        </Grid2>
                    </>
                )}
            />


            {/* <MainDialogBox open={open} handleClose={handleClose} width={"60%"}>
                <AddUserForm
                    onClose={handleClose}
                    RoleOption={[{
                        label: 'Marketing Manager',
                        value: "Marketing Manager"
                    },]}
                    role="user"
                />
            </MainDialogBox>
            <MainDialogBox open={openStudent} handleClose={handleCloseStudent} width={"60%"} >
                <AddUserForm
                    onClose={handleCloseStudent}
                    RoleOption={[{
                        label: 'student',
                        value: "student"
                    },]}
                    role='student'
                />
            </MainDialogBox> */}

        </>

    )
}

export default StudentEnquiryForm